import { put, all, takeLatest, select } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* getUsersSaga({ params }) {
    const { currentPage, perPage } = params;

    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const filters = yield select((state) => state.Users.filters);

        let queryString = `currentPage=${currentPage}&perPage=${perPage}`;
        if(filters.keyword) queryString = queryString.concat(`&keyword=${encodeURIComponent(filters.keyword)}`);

        const { data } = yield API.get(`/users?${queryString}`);
 
        if (data.success) {
            yield put({ type: actionTypes.GET_USERS_SUCCESS, payload: data.data });
        } else {
            toast.error(data?.message || "Could not load users list.");
            yield put({ type: actionTypes.GET_USERS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_USERS_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* getUserSaga({ params }) {
    const { key } = params;
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.get(`/users/${key}`);

        if (data.success) {
            yield put({ type: actionTypes.GET_USER_SUCCESS, payload: data.data });
        } else {
            toast.error(data?.message || "Could not load user data.");
            yield put({ type: actionTypes.GET_USER_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_USER_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* createUserSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { formData, navigate } = payload;

        const { data } = yield API.post("/users", formData);

        if (data.success) {
            yield put({ type: actionTypes.CREATE_USER_SUCCESS, payload: data.data });
            navigate("/users");
        } else {
            toast.error(data?.message || "Could not save user.");
            yield put({ type: actionTypes.CREATE_USER_FAILURE, payload: data, message: "Could not save user." });
        }

    } catch (error) {
        handleApiError(error, "Could not save user.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_USER_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* updateUserSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { formData, navigate } = payload;
        const id = formData.id;
        delete formData.id;

        const { data } = yield API.put(`/users/${id}`, formData);

        if (data.success) {
            yield put({ type: actionTypes.UPDATE_USER_SUCCESS, payload: data.data });
            navigate("/users");
        } else {
            toast.error(data?.message || "Could not update user.");
            yield put({ type: actionTypes.UPDATE_USER_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not update user.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.UPDATE_USER_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* updateUserStatusSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.get(`/users/change-status/${Id}`);

        if (data.success) {
            yield put({ type: actionTypes.DELETE_USER_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_USERS, params: {} });
        } else {
            toast.error(data?.message || "Could not update user status.");
            yield put({ type: actionTypes.DELETE_USER_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not update user status.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_USER_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* deleteUserSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.delete(`/users/${Id}`);
        if (data.success) {
            yield put({ type: actionTypes.DELETE_USER_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_USERS, params: {} });
        } else {
            toast.error(data?.message || "Could not delete user.");
            yield put({ type: actionTypes.DELETE_USER_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not delete user.");
        const data = error?.response?.data;
        toast.error(data?.message || "Could not delete user.");
        yield put({ type: actionTypes.CREATE_USER_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* getUserRolesSaga() {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.get(`/roles?keyword=all`);

        if (data.success) {
            yield put({ type: actionTypes.GET_USER_ROLES_SUCCESS, payload: data.data });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.GET_USER_ROLES_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_USER_ROLES_FAILURE, payload: data || { message: "Internal server error" } });
    }
};


function* UsersSaga() {
  yield all([
    takeLatest(actionTypes.GET_USERS, getUsersSaga),
    takeLatest(actionTypes.GET_USER, getUserSaga),
    takeLatest(actionTypes.CREATE_USER, createUserSaga),
    takeLatest(actionTypes.UPDATE_USER, updateUserSaga),
    takeLatest(actionTypes.DELETE_USER, deleteUserSaga),
    takeLatest(actionTypes.UPDATE_USER_STATUS, updateUserStatusSaga),
    takeLatest(actionTypes.GET_USER_ROLES, getUserRolesSaga),
  ]);
}

export default UsersSaga;
